<template>
  <div>
    <h1 v-html="modelValue.Content.StepFour.Title" />
    <section>
      <article class="flow-group">
        <div class="control">
          <h-3-and-tooltip
            :tooltip="modelValue.Content.StepFour.NumberOfClaimsTooltip"
            :h3="modelValue.Content.StepFour.NumberOfClaimsLabel"
          />
          <Field
            :rules="'required'"
            name="numberofclaims"
            :model-value="studyInsuranceSubmitTemplate.NumberOfClaims"
          >
            <base-radio-button-pills
              v-model="studyInsuranceSubmitTemplate.NumberOfClaims"
              option-label="Label"
              option-value="Value"
              :options="modelValue.Content.StepFour.NumberOfClaimsOptions"
              name="numberofclaims"
            />
          </Field>
          <ValidationError
            name="numberofclaims"
            :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
            mode="lazy"
          />
          <h-3-and-tooltip
            :tooltip="modelValue.Content.StepFour.NumberOfTheftClaimsTooltip"
            :h3="modelValue.Content.StepFour.NumberOfTheftClaimsLabel"
            class="push-up"
          />
          <Field
            :model-value="studyInsuranceSubmitTemplate.NumberOfTheftClaims"
            :rules="'required'"
            name="numberoftheftclaims"
          >
            <base-radio-button-pills
              v-model="studyInsuranceSubmitTemplate.NumberOfTheftClaims"
              option-label="Label"
              option-value="Value"
              :options="modelValue.Content.StepFour.NumberOfTheftClaimsOptions"
              name="numberoftheftclaims"
            />
          </Field>
          <ValidationError
            name="numberoftheftclaims"
            :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
            mode="lazy"
          />
          <div v-if="studyInsuranceSubmitTemplate.NumberOfTheftClaims > 0" class="push-up">
            <h-3-and-tooltip
              :tooltip="modelValue.Content.StepFour.NumberOfBikeTheftClaimsTooltip"
              :h3="modelValue.Content.StepFour.NumberOfBikeTheftClaimsLabel"
            />
            <Field
              :model-value="studyInsuranceSubmitTemplate.NumberOfBikeTheftClaims"
              :rules="'required'"
              name="numberofbiketheftclaims"
            >
              <base-radio-button-pills
                v-model="studyInsuranceSubmitTemplate.NumberOfBikeTheftClaims"
                option-label="Label"
                option-value="Value"
                :options="modelValue.Content.StepFour.NumberOfBikeTheftClaimsOptions"
                name="numberofbiketheftclaims"
              />
            </Field>
            <ValidationError
              name="numberofbiketheftclaims"
              :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
              mode="lazy"
            />
          </div>
          <h-3-and-tooltip
            :tooltip="modelValue.Content.StepFour.NumberOfAccidentClaimsTooltip"
            :h3="modelValue.Content.StepFour.NumberOfAccidentClaimsLabel"
          />
          <Field
            :model-value="studyInsuranceSubmitTemplate.NumberOfAccidentClaims"
            :rules="'required'"
            name="numberofaccidentclaims"
          >
            <base-radio-button-pills
              v-model="studyInsuranceSubmitTemplate.NumberOfAccidentClaims"
              option-label="Label"
              option-value="Value"
              :options="modelValue.Content.StepFour.NumberOfAccidentClaimsOptions"
              name="numberofaccidentclaims"
            />
          </Field>
          <ValidationError
            name="numberofaccidentclaims"
            :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
            mode="lazy"
          />
          <h-3-and-tooltip
            :tooltip="modelValue.Content.StepFour.PreviousCompanyDisclaimerTooltip"
            :h3="modelValue.Content.StepFour.PreviousCompanyDisclaimerLabel"
            class="push-up"
          />
          <p v-html="modelValue.Content.StepFour.PreviousCompanyDisclaimerBody" />
          <div class="row">
            <Field
              :rules="'required'"
              name="previouscompanydisclaimeranswer"
              :model-value="studyInsuranceSubmitTemplate.PreviousCompanyDisclaimerOption"
            >
              <div
                v-for="(option, index) in modelValue.Content.StepFour
                  .PreviousCompanyDisclaimerOptions"
                :key="index"
                class="small-6 columns"
              >
                <base-radio-buttons-stacked-study
                  v-model="studyInsuranceSubmitTemplate.PreviousCompanyDisclaimerOption"
                  :option="option"
                  :index="index"
                  name="previouscompanydisclaimeranswer"
                />
              </div>
            </Field>
            <div class="small-12 columns">
              <ValidationError
                name="previouscompanydisclaimeranswer"
                :overrides="{ required: modelValue.Content.Shared.LabelGenericErrorMessage }"
                mode="lazy"
              />
            </div>
          </div>
        </div>
      </article>
    </section>
  </div>
</template>

<script>
import BaseRadioButtonsStackedStudy from './BaseRadioButtonsStackedStudy.vue';
import StudyMixin from './StudyMixin.vue';
import BaseRadioButtonPills from '@/components/Forms/BaseRadioButtonPills.vue';
import H3AndTooltip from '@/components/UI/H3AndTooltip.vue';

export default {
  name: 'ClaimsStudy',
  components: {
    BaseRadioButtonPills,
    BaseRadioButtonsStackedStudy,
    H3AndTooltip
  },
  emits: ['update:modelValue', 'showstdstopmodal'],
  mixins: [StudyMixin],
  props: {
    modelValue: {
      type: Object,
      default() {
        return {};
      }
    },
    localModel: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    studyInsuranceSubmitTemplate: {
      get() {
        if (Object.prototype.hasOwnProperty.call(this.modelValue, 'Data')) {
          return this.modelValue.Data.StudyInsuranceSubmitTemplate;
        }
        return {};
      },
      set(val) {
        const tmp = { ...this.modelValue };
        tmp.Data.StudyInsuranceSubmitTemplate = val;
        this.$emit('update:modelValue', tmp);
      }
    }
  },
  watch: {
    'studyInsuranceSubmitTemplate.NumberOfClaims': function (val) {
      if (val === 4) {
        this.showStopModal();
      }
    },
    'studyInsuranceSubmitTemplate.NumberOfTheftClaims': function (val) {
      if (val === 3) {
        this.showStopModal();
      }
    },
    'studyInsuranceSubmitTemplate.NumberOfBikeTheftClaims': function (val) {
      if (val === 3) {
        this.showStopModal();
      }
    },
    'studyInsuranceSubmitTemplate.NumberOfAccidentClaims': function (val) {
      if (val === 4) {
        this.showStopModal();
      }
    },
    'studyInsuranceSubmitTemplate.PreviousCompanyDisclaimerOption': function (val) {
      if (val === 'Ja') {
        this.showStopModal();
      }
    }
  }
};
</script>
